import React from "react";
import { exact, number, shape, string } from "prop-types";
import styles from "./CoachStatisticsRow.module.styl";
import { Avatar } from "uikit/components";
import cx from "classnames";
import { percentageLevels } from "utils/indicator/indicatorSettings";

export default function CoachStatisticsRow({ coachStatistics, index }) {
    function getTextStyle(value) {
        return value != null ? styles.percentageText : styles.noPercentageText;
    }

    return (
        <div className={styles.container}>
            <div className={styles.index}>{index}.</div>
            <div className={styles.avatar}>
                <Avatar
                    size={"medium"}
                    shape={"circle"}
                    background={"grey"}
                    sex={coachStatistics.coachSex}
                    dataTestName="coach_avatar"
                />
            </div>
            <div className={styles.coachName}>{coachStatistics.coachName.officialFullName}</div>
            <div
                className={cx(
                    getTextStyle(coachStatistics.trainingsWithPlanFilledPercentage),
                    percentageLevels.indicatorColor(
                        coachStatistics.trainingsWithPlanFilledPercentage,
                    ).textStyle,
                )}
            >
                {coachStatistics.trainingsWithPlanFilledPercentage != null
                    ? coachStatistics.trainingsWithPlanFilledPercentage + "%"
                    : "нет тренировок"}
            </div>
            <div
                className={cx(
                    getTextStyle(coachStatistics.trainingsWithPresenceFilledPercentage),
                    percentageLevels.indicatorColor(
                        coachStatistics.trainingsWithPresenceFilledPercentage,
                    ).textStyle,
                )}
            >
                {coachStatistics.trainingsWithPresenceFilledPercentage != null
                    ? coachStatistics.trainingsWithPresenceFilledPercentage + "%"
                    : "нет тренировок"}
            </div>
            <div
                className={cx(
                    getTextStyle(coachStatistics.competitionsWithResultsFilledPercentage),
                    percentageLevels.indicatorColor(
                        coachStatistics.competitionsWithResultsFilledPercentage,
                    ).textStyle,
                )}
            >
                {coachStatistics.competitionsWithResultsFilledPercentage != null
                    ? coachStatistics.competitionsWithResultsFilledPercentage + "%"
                    : "нет соревнований"}
            </div>
            <div
                className={cx(
                    getTextStyle(coachStatistics.coachRatingPercentage),
                    styles.lastColumn,
                    percentageLevels.indicatorColor(coachStatistics.coachRatingPercentage)
                        .textStyle,
                )}
            >
                {coachStatistics.coachRatingPercentage != null
                    ? coachStatistics.coachRatingPercentage + "%"
                    : "нет данных"}
            </div>
        </div>
    );
}

CoachStatisticsRow.propTypes = {
    coachStatistics: shape({
        coachId: number.isRequired,
        coachName: exact({
            lastName: string.isRequired,
            firstName: string.isRequired,
            middleName: string,
            shortName: string.isRequired,
            fullName: string.isRequired,
            officialShortName: string.isRequired,
            officialFullName: string.isRequired,
            lastNameAndInitials: string.isRequired,
            firstNameAndMiddleName: string.isRequired,
        }),
        coachSex: string.isRequired,
        trainingsWithPlanFilledPercentage: number,
        trainingsWithPresenceFilledPercentage: number,
        competitionsWithResultsFilledPercentage: number,
        coachRatingPercentage: number,
    }),
    index: number.isRequired,
};
